import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import { Map } from 'immutable';

import { AutoCompleteF, CheckBoxFieldF } from 'modules/forms/component';
import * as validations from 'modules/forms/validations';
import { FORM_RESERVA } from 'modules/forms/formConstants';
import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';

import * as generalActions from 'modules/general/action';
import * as reservasActions from 'modules/reservas/action';
import * as trayectosActions from 'modules/trayectos/action';
import { CancelarButtonC } from 'modules/general/component';

import PasajeroC from './pasajero';
import SelectViajeC from './selectViaje';
import AcompanantesC from './acompanantes';
import ListaReservasC from './listaReservasUser';
import { PenalizacionesUsuarioC } from 'modules/penalizaciones/component';

import { cantAcompanantes } from 'core/constants';

const selector = formValueSelector(FORM_RESERVA);

class Add extends React.Component {
  componentDidMount = () => {
    const { dispatch, params } = this.props;
    dispatch(reservasActions.getViajeById(params.viajeId));
    if (params.reservaId === 'new') {
      dispatch(reservasActions.setTemporal(params.viajeId, 1));
      dispatch(generalActions.dashboard_changeTitle('AGREGAR RESERVA'));
    } else {
      this.props.dispatch(reservasActions.getById(params.reservaId));
      this.props.dispatch(generalActions.dashboard_changeTitle('MODIFICAR RESERVA'));
    }
  };
  componentDidUpdate = (prevProps) => {
    const { dispatch, reserva, paradasSalida, paradasDestino, params, viaje, paradaSubida, paradaBajada } = this.props;
    if (viaje.get('id') == params.viajeId) {
      if (!paradasSalida && reserva.get('_paradaSubida')) {
        const alias = reserva.getIn(['_paradaSubida', 'alias']),
          nombre = reserva.getIn(['_paradaSubida', 'nombre']);
        dispatch(
          trayectosActions.setState({
            [FORM_RESERVA + 'paradaSubida']: [
              {
                id: reserva.getIn(['_paradaSubida', 'id']),
                nombre: nombre,
                alias: alias || '',
                fullName: alias ? alias.concat(` (${nombre})`) : nombre,
              },
            ],
          }),
        );
      }
      if (!paradasDestino && reserva.get('_paradaBajada')) {
        const alias = reserva.getIn(['_paradaBajada', 'alias']),
          nombre = reserva.getIn(['_paradaBajada', 'nombre']);
        dispatch(
          trayectosActions.setState({
            [FORM_RESERVA + 'paradaBajada']: [
              {
                id: reserva.getIn(['_paradaBajada', 'id']),
                nombre: nombre,
                alias: alias || '',
                fullName: alias ? alias.concat(` (${nombre})`) : nombre,
              },
            ],
          }),
        );
      }
    }
    if (params.reservaId == 'new') {
      const prevDatosUsuario =
          (prevProps.pasajero && prevProps.pasajero.get('usuarioId') && { tipo: 'usuarioId', id: prevProps.pasajero.get('usuarioId') }) ||
          (prevProps.pasajero && prevProps.pasajero.get('abonadoId') && { tipo: 'abonadoId', id: prevProps.pasajero.get('abonadoId') }) ||
          (prevProps.pasajero && prevProps.pasajero.get('usuarioCasualId') && { tipo: 'usuarioCasualId', id: prevProps.pasajero.get('usuarioCasualId') }) ||
          null,
        datosUsuario =
          (this.props.pasajero.get('usuarioId') && { tipo: 'usuarioId', id: this.props.pasajero.get('usuarioId') }) ||
          (this.props.pasajero.get('abonadoId') && { tipo: 'abonadoId', id: this.props.pasajero.get('abonadoId') }) ||
          (this.props.pasajero.get('usuarioCasualId') && { tipo: 'usuarioCasualId', id: this.props.pasajero.get('usuarioCasualId') }) ||
          null;

      if ((!prevDatosUsuario && datosUsuario) || (datosUsuario && (prevDatosUsuario || {}).id != datosUsuario.id)) {
        viaje && viaje.get('trayectoId') && !paradaSubida && !paradaBajada && dispatch(trayectosActions.getParadasUser(viaje.get('trayectoId'), datosUsuario.id, datosUsuario.tipo, FORM_RESERVA));
      }
      if (viaje.get('trayectoId') && viaje.get('trayectoId') != prevProps.viaje.get('trayectoId')) {
        dispatch(trayectosActions.getParadas(viaje.get('trayectoId'), undefined, undefined, [FORM_RESERVA + 'paradaSubida', FORM_RESERVA + 'paradaBajada']));
      }
    }
  };
  componentWillUnmount = () => {
    const { dispatch, params } = this.props;
    dispatch(reservasActions.clear('viaje'));
    dispatch(reservasActions.clear('pasajero'));
    dispatch(reservasActions.clear('reserva'));
    dispatch(reservasActions.clear('reservasPrevias'));
    dispatch(reservasActions.clear('showListaReservas'));
    dispatch(trayectosActions.clear('all'));
    dispatch(reservasActions.deleteTemporal(params.viajeId));
  };
  setPopup = (data) => this.props.dispatch(reservasActions.setState(data));
  submitForm = (data) => {
    let dataClon = Object.assign({}, data.toJS());
    if (this.props.params.reservaId !== 'new') dataClon.reservaId = this.props.params.reservaId;
    if (this.props.reserva.get('cancelada')) this.props.dispatch(reservasActions.cancelarReserva(this.props.params.reservaId, false));
    this.props.dispatch(reservasActions.set(dataClon));
  };
  forceSubmit = (data) => {
    data = data.toJS();
    if (this.props.params.reservaId !== 'new') data.reservaId = this.props.params.reservaId;
    if (this.props.reserva.get('cancelada')) this.props.dispatch(reservasActions.cancelarReserva(this.props.params.reservaId, false));
    this.props.dispatch(reservasActions.set(data, true));
  };
  findParada = (value, lista, fieldName, { source }) => {
    if (value.length == 0) return this.props.change(fieldName, null);
    try {
      if (source == 'change' && lista) {
        this.props.dispatch(trayectosActions.buscarParada(this.props.viaje.get('trayectoId'), value, FORM_RESERVA + fieldName));
      }
    } catch (e) {
      return;
    }
  };
  onFocusParadas = (trayectoId, formName) => this.props.dispatch(trayectosActions.getParadas(trayectoId, undefined, undefined, [FORM_RESERVA + formName]));
  render() {
    const { viaje, reservaLlena, invalid, dispatch, pasajero } = this.props;
    let { paradasSalida, paradasDestino } = this.props;
    (paradasSalida = paradasSalida ? paradasSalida.toJS() : []), (paradasDestino = paradasDestino ? paradasDestino.toJS() : []);
    return (
      <div>
        <MaterialUI.Paper zDepth={2} className="container">
          <form onSubmit={this.props.handleSubmit(this.submitForm)}>
            <Row className="rowContainer baseline">
              <Col md="4">
                <MaterialUI.Subheader>
                  <h4 className="mt-10">Viaje</h4>
                </MaterialUI.Subheader>
                <SelectViajeC change={this.props.change} />
                <Field
                  name="abonada"
                  component={CheckBoxFieldF}
                  inputProps={{
                    label: 'Reserva abonada',
                    style: { paddingTop: 25 },
                  }}
                />
                <Field
                  name="cuentaCorriente"
                  component={CheckBoxFieldF}
                  inputProps={{
                    label: 'Cuenta Corriente',
                    style: { paddingBottom: 25 },
                  }}
                />
                <MaterialUI.Divider style={{ marginBottom: 10 }} />
                <Field
                  name="paradaSubida"
                  component={AutoCompleteF}
                  inputProps={{
                    openOnFocus: true,
                    fullWidth: true,
                    dataSource: paradasSalida || [],
                    hintText: 'Parada salida',
                    onUpdateInput: (value, lista, source) => this.findParada(value, lista, 'paradaSubida', source),
                    dataSourceConfig: { text: 'fullName', value: 'id' },
                    filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                  }}
                  onBlur={(e) => e.preventDefault()}
                  onFocus={(e) => e.target.select()}
                  validate={[validations.required, validations.noObject]}
                />
                <Field
                  name="paradaBajada"
                  component={AutoCompleteF}
                  inputProps={{
                    openOnFocus: true,
                    fullWidth: true,
                    dataSource: paradasDestino || [],
                    hintText: 'Parada llegada',
                    onUpdateInput: (value, lista, source) => this.findParada(value, lista, 'paradaBajada', source),
                    dataSourceConfig: { text: 'fullName', value: 'id' },
                    filter: MaterialUI.AutoComplete.caseInsensitiveFilter,
                  }}
                  onBlur={(e) => e.preventDefault()}
                  onFocus={(e) => e.target.select()}
                  validate={[validations.noObject]}
                />
              </Col>
              <Col md="8">
                <MaterialUI.Subheader>
                  <h4 className="mt-10">Pasajero</h4>
                </MaterialUI.Subheader>
                <PasajeroC className="divider" pasajero={pasajero || Map()} change={this.props.change} />
                <MaterialUI.Subheader>
                  <h4 className="mt-10">Acompañantes</h4>
                </MaterialUI.Subheader>
                <AcompanantesC className="divider" cant={cantAcompanantes} edicion={this.props.params.reservaId === 'new' ? false : true} />
              </Col>
            </Row>
            {viaje.get('horario') && <SeeViajeC viajeId={viaje.get('id')} horario={viaje.get('horario')} viaje={viaje} />}
            <MaterialUI.RaisedButton className="fullWidthComponent noPadding m-tb-20" label="GUARDAR" primary={true} type="submit" disabled={invalid || reservaLlena} />
          </form>
          <ListaReservasC handleSubmit={() => this.props.handleSubmit(this.forceSubmit)} />
          <PenalizacionesUsuarioC handleSubmit={() => this.props.handleSubmit(this.forceSubmit)} />
        </MaterialUI.Paper>
        <CancelarButtonC className="m-tb-20" dispatch={dispatch} />
      </div>
    );
  }
}

@connect((store, props) => {
  let dia = 'buscado',
    diff = moment().startOf('day').diff(props.horario, 'days');
  if (diff === 0) dia = 'hoy';
  else if (diff === -1) dia = 'manana';
  return {
    cantReservas: (store.getIn(['viajes', dia]).find((v) => props.viajeId == v.get('id')) || Map()).get('cantReservas'),
  };
})
class SeeViajeC extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { viaje, cantReservas } = this.props;
    return (
      <div className="m-20">
        <MaterialUI.Divider />
        <MaterialUI.Table selectable={false}>
          <MaterialUI.TableBody displayRowCheckbox={false}>
            <MaterialUI.TableRow selectable={false}>
              <MaterialUI.TableRowColumn>
                <MaterialUI.Subheader>
                  <b>Viaje seleccionado:</b>
                </MaterialUI.Subheader>
              </MaterialUI.TableRowColumn>
              <MaterialUI.TableRowColumn>
                <b>Fecha:</b> {moment(viaje.get('horario')).format('D MMMM')}
              </MaterialUI.TableRowColumn>
              <MaterialUI.TableRowColumn>
                <b>Horario:</b> {moment(viaje.get('horario')).format('HH:mm')}
              </MaterialUI.TableRowColumn>
              <MaterialUI.TableRowColumn>
                <b>Salida:</b> {moment(viaje.get('horario')).fromNow()}
              </MaterialUI.TableRowColumn>
              <MaterialUI.TableRowColumn>
                <b>Reservas:</b> {cantReservas || 0} / {viaje.get('cantAsientos')}
              </MaterialUI.TableRowColumn>
            </MaterialUI.TableRow>
          </MaterialUI.TableBody>
        </MaterialUI.Table>
        <MaterialUI.Divider />
      </div>
    );
  }
}

Add = reduxForm({
  form: FORM_RESERVA,
  enableReinitialize: true,
})(Add);

Add = connect((store, props) => {
  const usuario = store.getIn(['reservas', 'reserva', '_usuario']) || store.getIn(['reservas', 'reserva', '_usuarioCasual']) || store.getIn(['reservas', 'reserva', '_usuarioAbonado']) || Map();
  return {
    viaje: store.getIn(['reservas', 'viaje']),
    paradasSalida: store.getIn(['trayectos', FORM_RESERVA + 'paradaSubida']),
    paradasDestino: store.getIn(['trayectos', FORM_RESERVA + 'paradaBajada']),
    reserva: store.getIn(['reservas', 'reserva']),
    reservaLlena: store.getIn(['reservas', 'reservaLlena']),
    pasajero: selector(store, 'usuario'),
    paradaSubida: selector(store, 'paradaSubida'),
    paradaBajada: selector(store, 'paradaBajada'),
    initialValues: {
      viajeId: store.getIn(['reservas', 'reserva', 'viajeId']) || props.params.viajeId,
      paradaSubida: store.getIn(['reservas', 'reserva', '_paradaSubida', 'id']),
      paradaBajada: store.getIn(['reservas', 'reserva', '_paradaBajada', 'id']),
      acompanantes: store.getIn(['reservas', 'reserva', 'acompanantes']),
      abonada: store.getIn(['reservas', 'reserva', 'abonada']),
      usuario: {
        nombre: usuario.get('nombre'),
        apellido: usuario.get('apellido'),
        documento: usuario.get('documento'),
        usuarioId: store.getIn(['reservas', 'reserva', 'usuarioId']),
        abonadoId: store.getIn(['reservas', 'reserva', 'abonadoId']),
        tipoDoc: usuario.get('tipoDoc') || 'DNI',
        usuarioCasualId: store.getIn(['reservas', 'reserva', 'usuarioCasualId']),
      },
    },
  };
})(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/reservas/components/add.js